<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的问答>去提问</p>
        </div>
        <div class="menu">
            <center-menu active="8" />
        </div>
        <div class="content">
            <div class="title">
                <h1>提问 <span> / Put questions to</span></h1>
            </div>
            <p>给考试中心留言</p>
            <el-form :model="questions" :rules="questionsRules" ref="questions" label-width="72px" label-position="left" @submit.native.prevent>
                <el-form-item label="问题分类:" prop="questionTypeId">
                    <el-select clearable v-model="questions.questionTypeId" placeholder="请选择问题分类">
                        <el-option
                            v-for="item in typeList"
                            :key="item.typeValue"
                            :label="item.typeName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问题内容:" prop="question">
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入问题内容"
                        style="width: 375px;"
                        v-model="questions.question">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="buttons">
                <el-button :loading="submitLoading" @click="submit" >提交</el-button>
            </div>
            <p class="rexian">热线电话： 010-53391240  <span>010-53391241</span>   </p>
        </div>
    </div>
</template>

<script>
import { questionAdd,questionTypeList } from '@/api/center'
import pagination from '@/components/pagination'	
export default {
    name: 'askQuestions',
    components: {
		pagination
    },
    data(){
        return {
            questions: {
                questionTypeId:null,
                question:null,
				userId:this.$store.getters.userInfo.id,
            },
            questionsRules:{

            },
            typeList:[],
            submitLoading:false,
        }
    },
    mounted(){
		questionTypeList({}).then(res => {
			this.typeList=res
		})
    },
    methods:{
		submit(){
			questionAdd(this.questions).then(res => {
				this.$router.push('/center/questionsAnswers')
			})
		}
    }
}
</script>

<style scoped>
.menu{float: left;width: 170px;}
.content{float: right;width: 1028px;}
.content p {
    font-size: 16px;
    padding: 30px 0;
}
.content>>>.el-form-item__label{
    color: #000;
}
.content>>>textarea{
    border-color: #999999;
    border-radius: 0;
}
.content>>>.el-form {
    margin-bottom: 50px;
}
.content .rexian{
    color: #666;
    padding: 0;
    padding-top: 10px;
}
.rexian span{
    margin-left: 15px;
}
</style>
